import { render, staticRenderFns } from "./FormularioCtrlWorkflowComponent.vue?vue&type=template&id=499d48ba"
import script from "./FormularioCtrlWorkflowComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCtrlWorkflowComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports